import { BookOpen, Check, FileText } from "lucide-react";
import { useLoopStep } from "./useLoopStep";
import "./how-mocks.css";

const files = [
  { name: "Services & prices.pdf", topic: "Services & pricing", detail: "24 items" },
  { name: "FAQs.docx", topic: "Frequently asked questions", detail: "38 answers" },
  { name: "Policies.pdf", topic: "Policies", detail: "9 rules" },
  { name: "First visit SOP", topic: "Procedures", detail: "6 steps" },
];

/** Documents are read in one by one and organised into a knowledge base. */
export default function KnowledgeMock() {
  const [ref, step] = useLoopStep(13, 650);
  return (
    <div className="hm lm" ref={ref}>
      <div className="lm-files">
        {files.map((file, i) => (
          <div className={`lm-file${step >= 2 * i + 1 ? " is-on" : ""}`} key={file.name}>
            <span className="lm-file-icon"><FileText aria-hidden /></span>
            <span className="lm-file-name">{file.name}</span>
            <Check className="lm-file-check" aria-hidden />
          </div>
        ))}
      </div>
      <div className={`lm-link${step >= 1 && step <= 8 ? " is-active" : ""}`} aria-hidden><i /><i /><i /></div>
      <div className="lm-card">
        <div className="lm-card-head">
          <span className="lm-avatar lm-avatar--icon"><BookOpen aria-hidden /></span>
          <div><strong>Knowledge base</strong><small>{step >= 2 ? "Organising…" : "Waiting for documents"}</small></div>
        </div>
        {files.map((file, i) => (
          <div className={`lm-fact${step >= 2 * i + 2 ? " is-on" : ""}`} key={file.topic}>
            <b>{file.topic}</b>
            <small>{file.detail}</small>
          </div>
        ))}
        <span className={`lm-ready${step >= 9 ? " is-on" : ""}`}><Check aria-hidden />Ready to use</span>
      </div>
    </div>
  );
}
